module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', {
    staticClass: "content"
  }, [_c('b', [_vm._v("Selected:")]), _vm._v(" " + _vm._s(_vm.selected))]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Find a movie"
    }
  }, [_c('b-autocomplete', {
    attrs: {
      "data": _vm.data,
      "placeholder": "e.g. Fight Club",
      "field": "title",
      "loading": _vm.isFetching,
      "check-infinite-scroll": true
    },
    on: {
      "typing": _vm.getAsyncData,
      "select": function (option) { return _vm.selected = option; },
      "infinite-scroll": _vm.getMoreAsyncData
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('div', {
          staticClass: "media"
        }, [_c('div', {
          staticClass: "media-left"
        }, [_c('img', {
          attrs: {
            "width": "32",
            "src": ("https://image.tmdb.org/t/p/w500/" + (props.option.poster_path))
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "media-content"
        }, [_vm._v("\n                            " + _vm._s(props.option.title) + "\n                            "), _c('br'), _vm._v(" "), _c('small', [_vm._v("\n                                Released at " + _vm._s(props.option.release_date) + ",\n                                rated "), _c('b', [_vm._v(_vm._s(props.option.vote_average))])])])])]
      }
    }])
  }, [_c('template', {
    slot: "footer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page > _vm.totalPages),
      expression: "page > totalPages"
    }],
    staticClass: "has-text-grey"
  }, [_vm._v(" Thats it! No more movies found. ")])])], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-561be0a5"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/autocomplete/examples/ExInfiniteScroll.vue
// module id = 970
// module chunks = 6 33